import React from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { isDeviationPixelArt, isFileLargerThanSize, } from '../../../DeviationViews/_helpers';
import MediaService from '../../../utils/DeviationMediaService';
import ContentShadow from '../_partials/ContentShadow';
import ImageContent from './ImageContent';
import ZoomModal from './ZoomModal';
import { useDeviationViewContext } from '../../../Context';
import s from './Image.scss';
export var ImageFullView = function (_a) {
    var width = _a.width, height = _a.height, deviation = _a.deviation, isZoomed = _a.isZoomed, onEnterZoomMode = _a.onEnterZoomMode, onExitZoomMode = _a.onExitZoomMode;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isPixel = isDeviationPixelArt(deviation);
    var zoomedFile = MediaService.getLargestFullview(deviation);
    var isHuge = !!zoomedFile && isFileLargerThanSize(zoomedFile, width, height);
    var file = isHuge
        ? MediaService.getFullviewForSize(deviation, isZoomed ? 0 : width, isZoomed ? 0 : height)
        : zoomedFile;
    if (!file) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], isFullscreen && s['fullscreen']), style: { width: width, height: height } },
        React.createElement(Helmet, null,
            React.createElement("link", { rel: "preload", href: file.src, as: "image" })),
        isZoomed && zoomedFile && (React.createElement(ZoomModal, { file: zoomedFile, isPixel: isPixel, onClose: onExitZoomMode })),
        React.createElement(ContentShadow, { content: file, containerSize: { width: width, height: height }, useSmallStage: true, className: s['shadow'] },
            React.createElement(ImageContent, { key: file.src, width: width, height: height, file: file, isPixel: isPixel, canZoom: isHuge, onZoom: onEnterZoomMode }))));
};
ImageFullView.displayName = 'ImageFullView';
export default ImageFullView;
//# sourceMappingURL=Image.js.map